import React from 'react';
import LocationTemplate from './LocationTemplate';

const AydenPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Ayden"
      stateName="North Carolina"
      countyName="Pitt"
      zipCodes={["28513"]}
      latitude={35.4688}
      longitude={-77.4169}
      population={5069}
      historicalFact="Originally called 'Darden,' but renamed as mail was being confused with nearby Warden."
      nearbyTowns={[
        "Winterville, NC",
        "Greenville, NC",
        "Grifton, NC",
        "Snow Hill, NC",
        "Kinston, NC",
        "Farmville, NC",
        "Bethel, NC",
        "Dover, NC"
      ]}
    />
  );
};

export default AydenPage;